import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import ProductCard from "./ProductCard";
import { useState } from "react";

function ProductsView({ products, setProducts, fetchProducts }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");

  const handleSearch = (e) => {
    e.preventDefault();

    fetch(`${process.env.REACT_APP_API_BASE_URL}/products/search-by-name`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: searchTerm,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        // Handle the search results
        setProducts(data);
        console.log("Search results:", data);
      })
      .catch((error) => {
        console.error("Error fetching search results:", error);
      });
  };

  const handleRangeSearch = (e) => {
    e.preventDefault();

    fetch(`${process.env.REACT_APP_API_BASE_URL}/products/search-by-price`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        minPrice: parseFloat(minPrice),
        maxPrice: parseFloat(maxPrice),
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        // Handle the filtered results
        setProducts(data);
        console.log("Filtered results:", data);
      })
      .catch((error) => {
        console.error("Error fetching filtered results:", error);
      });
  };

  return (
    <div className="products-view-wrapper">
      {/* Hero Section */}
      <div className="products-hero-section">
        <Container>
          <div className="text-center py-5">
            <h1 className="display-4 fw-bold text-white mb-3">Our Products</h1>
            <p className="lead text-white-50 mb-4">
              Discover our premium selection of fresh and quality products
            </p>
            <div className="hero-divider mx-auto"></div>
          </div>
        </Container>
      </div>
      {/* Search Filters  */}
      <Container className="my-5">
        <Card className="shadow-sm border-0 search-form-card">
          <Card.Body className="p-4">
            <h5 className="mb-3 text-center search-title">
              <i className="fas fa-search me-2"></i>
              Search Products
            </h5>
            <form className="d-flex mb-4" onSubmit={(e) => handleSearch(e)}>
              <Row className="w-100 g-3 align-items-center">
                <Col xs={12} sm={8} md={9}>
                  <Form.Control
                    type="text"
                    placeholder="Search products by name..."
                    aria-label="Search"
                    className="search-input"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </Col>
                <Col xs={6} sm={2} md={1}>
                  <Button
                    variant="success"
                    type="submit"
                    className="w-100 search-btn"
                  >
                    <i className="fas fa-search me-2"></i>
                    Search
                  </Button>
                </Col>
                <Col xs={6} sm={2} md={1}>
                  <Button
                    variant="success"
                    onClick={fetchProducts}
                    className="w-100 search-btn"
                  >
                    <i className="fas fa-rotate-left me-2"></i>
                    Reset
                  </Button>
                </Col>
              </Row>
            </form>

            <hr className="filter-divider" />

            <h6 className="mb-3 text-center filter-title">
              <i className="fas fa-filter me-2"></i>
              Price Range Filter
            </h6>
            <Form className="row g-3 align-items-center justify-content-center">
              <Col xs={6} md={3}>
                <Form.Label
                  htmlFor="minPrice"
                  className="small text-muted mb-1"
                >
                  Minimum Price
                </Form.Label>
                <Form.Control
                  id="minPrice"
                  type="number"
                  placeholder="₱0.00"
                  min={0}
                  step={0.01}
                  className="price-input"
                  value={minPrice}
                  onChange={(e) => setMinPrice(e.target.value)}
                />
              </Col>
              <Col xs={6} md={3}>
                <Form.Label
                  htmlFor="maxPrice"
                  className="small text-muted mb-1"
                >
                  Maximum Price
                </Form.Label>
                <Form.Control
                  id="maxPrice"
                  type="number"
                  placeholder="₱999.99"
                  min={0}
                  step={0.01}
                  className="price-input"
                  value={maxPrice}
                  onChange={(e) => setMaxPrice(e.target.value)}
                />
              </Col>
              <Col xs={12} md={3}>
                <Form.Label className="small text-muted mb-1 d-block">
                  &nbsp;
                </Form.Label>
                <Button
                  variant="outline-success"
                  type="submit"
                  onClick={handleRangeSearch}
                  className="w-100 filter-btn"
                >
                  <i className="fas fa-filter me-2"></i>
                  Apply Filter
                </Button>
              </Col>
            </Form>
          </Card.Body>
        </Card>
      </Container>
      {/* Products Grid Section */}
      <Container className="py-5">
        {products && products.length > 0 ? (
          <Row className="g-4">
            {products.map((product) => (
              <Col key={product._id} xs={12} sm={6} md={4} lg={3}>
                <ProductCard product={product} />
              </Col>
            ))}
          </Row>
        ) : (
          <div className="text-center py-5">
            <Card className="border-0 shadow-sm">
              <Card.Body className="py-5">
                <i
                  className="fas fa-box-open text-muted mb-3"
                  style={{ fontSize: "3rem" }}
                ></i>
                <h5 className="text-muted">No products available</h5>
                <p className="text-muted mb-0">
                  Check back soon for new arrivals!
                </p>
              </Card.Body>
            </Card>
          </div>
        )}
      </Container>
      {/* Custom Styles */}
      <style jsx>{`
        .products-view-wrapper {
          min-height: 100vh;
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
        }

        .products-hero-section {
          background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
          position: relative;
          overflow: hidden;
        }

        .products-hero-section::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="white" opacity="0.1"/><circle cx="75" cy="75" r="1" fill="white" opacity="0.1"/><circle cx="50" cy="10" r="0.5" fill="white" opacity="0.15"/><circle cx="90" cy="40" r="0.5" fill="white" opacity="0.15"/><circle cx="10" cy="60" r="0.5" fill="white" opacity="0.15"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
          pointer-events: none;
        }

        .hero-divider {
          width: 80px;
          height: 4px;
          background: linear-gradient(90deg, transparent, white, transparent);
          border-radius: 2px;
        }

        /* Search Form Styles */
        .search-form-card {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(10px);
          border-radius: 15px;
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }

        .search-form-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(40, 167, 69, 0.15) !important;
        }

        .search-title {
          color: #28a745;
          font-weight: 600;
          margin-bottom: 1.5rem;
        }

        .filter-title {
          color: #20c997;
          font-weight: 500;
        }

        .filter-divider {
          border-top: 2px solid #e9ecef;
          background: linear-gradient(90deg, transparent, #28a745, transparent);
          height: 2px;
          border: none;
          margin: 2rem 0;
        }

        .search-input,
        .price-input {
          border: 2px solid #e9ecef;
          border-radius: 10px;
          padding: 12px 16px;
          font-size: 1rem;
          transition: all 0.3s ease;
          background: rgba(255, 255, 255, 0.9);
        }

        .search-input:focus,
        .price-input:focus {
          border-color: #28a745;
          box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.15);
          background: white;
          transform: translateY(-1px);
        }

        .search-btn {
          background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
          border: none;
          border-radius: 10px;
          padding: 12px 16px;
          font-weight: 600;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);
        }

        .search-btn:hover {
          background: linear-gradient(135deg, #218838 0%, #1bb890 100%);
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(40, 167, 69, 0.4);
        }

        .filter-btn {
          border: 2px solid #28a745;
          border-radius: 10px;
          padding: 12px 16px;
          font-weight: 500;
          transition: all 0.3s ease;
          color: #28a745;
          background: rgba(40, 167, 69, 0.05);
        }

        .filter-btn:hover {
          background: #28a745;
          border-color: #28a745;
          color: white;
          transform: translateY(-1px);
          box-shadow: 0 4px 15px rgba(40, 167, 69, 0.25);
        }

        @media (max-width: 768px) {
          .products-hero-section .display-4 {
            font-size: 2.5rem;
          }

          .products-hero-section .py-5 {
            padding: 3rem 0 !important;
          }
        }
      `}</style>
    </div>
  );
}

export default ProductsView;
